import Axios from 'axios';

export default {
  generateReport: params => Axios.post('report/generatereport', params)
};
